import { NavLink, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { classNames } from "../../AppNav";

const tabs = [
  { label: "Plays", path: "" },
  { label: "Brain", path: "/brain" },
  { label: "Settings", path: "/settings" },
] as const;

export default function GtmLeadsSubnav() {
  const { t } = useTranslation();
  const { projectId } = useParams<{ projectId: string }>();
  const base = `/workspaces/${projectId}/gtm/leads`;

  return (
    <nav className="flex gap-1 border-b border-gray-200 px-4" aria-label={t("GTM Leads")}>
      {tabs.map((tab) => {
        const to = `${base}${tab.path}?key=Leads`;
        const end = tab.path === "";
        return (
          <NavLink
            key={tab.label}
            to={to}
            end={end}
            className={({ isActive }) =>
              classNames(
                isActive
                  ? "border-blue-600 text-blue-600"
                  : "border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300",
                "border-b-2 px-3 py-2.5 text-sm font-medium"
              )
            }
          >
            {t(tab.label)}
          </NavLink>
        );
      })}
    </nav>
  );
}
